module.exports = __webpack_public_path__ + "static/img/Frame 18.d04d0612.png";